// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-icon.show-hide-pass {
  z-index: 999;
  font-size: 20px;
  position: absolute;
  right: 0;
  bottom: 8px;
}

ion-content .my-custom-class {
  border-radius: 20px;
}

.centrar-pantalla {
  display: flex;
  align-items: center;
}

.centrar-vertical {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
}

.centrar-horizontal {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.clave-text {
  text-align: center; /* Añadido para centrar el texto */
  color: #747474; /* Color del texto para la condición */
  font-size: 11px;
}

.border-radius {
  border-radius: 30px; /* Puedes ajustar el valor según la cantidad de redondeo que desees */
}

.my-custom-class {
  border-radius: 20px;
}

.padding {
  padding: 0px 100px;
}
@media only screen and (max-width: 600px) {
  .padding {
    padding: 0px 0px;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNsYXZlLWZpc2NhbC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxnQkFBZ0I7QUFBaEI7RUFDRSxZQUFBO0VBQ0EsZUFBQTtFQUNBLGtCQUFBO0VBQ0EsUUFBQTtFQUNBLFdBQUE7QUFFRjs7QUFDRTtFQUNFLG1CQUFBO0FBRUo7O0FBQ0E7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7QUFFRjs7QUFDQTtFQUNFLGFBQUE7RUFDQSxzQkFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7RUFDQSxZQUFBO0FBRUY7O0FBQ0E7RUFDRSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSxtQkFBQTtBQUVGOztBQUNBO0VBQ0Usa0JBQUEsRUFBQSxrQ0FBQTtFQUNBLGNBQUEsRUFBQSxzQ0FBQTtFQUNBLGVBQUE7QUFFRjs7QUFDQTtFQUNFLG1CQUFBLEVBQUEscUVBQUE7QUFFRjs7QUFDQTtFQUNFLG1CQUFBO0FBRUY7O0FBQ0E7RUFDRSxrQkFBQTtBQUVGO0FBREU7RUFGRjtJQUdJLGdCQUFBO0VBSUY7QUFDRiIsImZpbGUiOiJjbGF2ZS1maXNjYWwuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJpb24taWNvbi5zaG93LWhpZGUtcGFzcyB7XG4gIHotaW5kZXg6IDk5OTtcbiAgZm9udC1zaXplOiAyMHB4O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHJpZ2h0OiAwO1xuICBib3R0b206IDhweDtcbn1cbmlvbi1jb250ZW50IHtcbiAgLm15LWN1c3RvbS1jbGFzcyB7XG4gICAgYm9yZGVyLXJhZGl1czogMjBweDtcbiAgfVxufVxuLmNlbnRyYXItcGFudGFsbGEge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4uY2VudHJhci12ZXJ0aWNhbCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBoZWlnaHQ6IDcwdmg7XG59XG5cbi5jZW50cmFyLWhvcml6b250YWwge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4uY2xhdmUtdGV4dCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjsgLyogQcOxYWRpZG8gcGFyYSBjZW50cmFyIGVsIHRleHRvICovXG4gIGNvbG9yOiAjNzQ3NDc0OyAvKiBDb2xvciBkZWwgdGV4dG8gcGFyYSBsYSBjb25kaWNpw7NuICovXG4gIGZvbnQtc2l6ZTogMTFweDtcbn1cblxuLmJvcmRlci1yYWRpdXMge1xuICBib3JkZXItcmFkaXVzOiAzMHB4OyAvKiBQdWVkZXMgYWp1c3RhciBlbCB2YWxvciBzZWfDum4gbGEgY2FudGlkYWQgZGUgcmVkb25kZW8gcXVlIGRlc2VlcyAqL1xufVxuXG4ubXktY3VzdG9tLWNsYXNzIHtcbiAgYm9yZGVyLXJhZGl1czogMjBweDtcbn1cblxuLnBhZGRpbmcge1xuICBwYWRkaW5nOiAwcHggMTAwcHg7XG4gIEBtZWRpYSBvbmx5IHNjcmVlbiBhbmQgKG1heC13aWR0aDogNjAwcHgpIHtcbiAgICBwYWRkaW5nOiAwcHggMHB4O1xuICB9XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/components/shared/clave-fiscal/clave-fiscal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAEF;;AACE;EACE,mBAAA;AAEJ;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA,EAAA,kCAAA;EACA,cAAA,EAAA,sCAAA;EACA,eAAA;AAEF;;AACA;EACE,mBAAA,EAAA,qEAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;AADE;EAFF;IAGI,gBAAA;EAIF;AACF;AACA,w+DAAw+D","sourcesContent":["ion-icon.show-hide-pass {\n  z-index: 999;\n  font-size: 20px;\n  position: absolute;\n  right: 0;\n  bottom: 8px;\n}\nion-content {\n  .my-custom-class {\n    border-radius: 20px;\n  }\n}\n.centrar-pantalla {\n  display: flex;\n  align-items: center;\n}\n\n.centrar-vertical {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n}\n\n.centrar-horizontal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.clave-text {\n  text-align: center; /* Añadido para centrar el texto */\n  color: #747474; /* Color del texto para la condición */\n  font-size: 11px;\n}\n\n.border-radius {\n  border-radius: 30px; /* Puedes ajustar el valor según la cantidad de redondeo que desees */\n}\n\n.my-custom-class {\n  border-radius: 20px;\n}\n\n.padding {\n  padding: 0px 100px;\n  @media only screen and (max-width: 600px) {\n    padding: 0px 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
